export default class SpecialDestinationCandidate {
  constructor(name, type, recruitersCount, description) {
    this.name = name
    this.type = type
    this.recruitersCount = recruitersCount == null || recruitersCount === '' ? null : recruitersCount
    this.description = description || null
  }

  static fromJson(json) {
    return new SpecialDestinationCandidate(json.name, json.type, json.recruiters_count, json.description)
  }
}
